import { render } from "./JoinItem.vue?vue&type=template&id=1c5ee695&scoped=true"
import script from "./JoinItem.vue?vue&type=script&lang=js"
export * from "./JoinItem.vue?vue&type=script&lang=js"

import "./JoinItem.vue?vue&type=style&index=0&id=1c5ee695&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c5ee695"]])

export default __exports__